const ReactDOM = require('react-dom');

const UrlHelper = {
    scrollTo( component ) {
        let node = ReactDOM.findDOMNode(component);

        if (node) {
            node.scrollIntoView();
        }
    },

    isAbsolute(url) {
        return /^[a-z][a-z0-9+.-]*:/i.test(url)
    },

    getDomainFromUrl(url) {
        return(url.replace(/(^\w+:|^)\/\//, ''));
    },

    getQueryParams(query) {
        return query.split('&').reduce(function (q, query) {
            var chunks = query.split('=');
            var key = chunks[0];
            var value = chunks[1];
            return (q[key] = value, q);
        }, {});
    }
}

module.exports = UrlHelper;
